import { Http } from '../../support';

const initialState = {
  isValidForm: false,
  busy: false,
  data: {
    live: false,
  },
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.layouts.empresa.tenant = {
      ...state.layouts.empresa.tenant,
      ...data,
    };
  });
};

const live = async (store, live) => {
  store.setState((state) => {
    state.layouts.empresa.tenant.busy = true;
  });

  try {
    const body = { live };

    const response = await Http.patch(`auth/me/live`, body);

    store.setState((state) => {
      state.layouts.empresa.tenant = {
        ...state.layouts.empresa.tenant,
        busy: false,
        data: response.data,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.layouts.empresa.tenant.busy = false;
      state.layouts.empresa.tenant.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.layouts.empresa.tenant = { ...initialState };
  });
  this.setState({
    ...initialState,
    __action: 'reset',
  });
};

const EmpresaTenantStore = {
  state: { ...initialState },
  actions: {
    setPartialState,
    live,
    reset,
  },
};

export default EmpresaTenantStore;
